import { constructs } from "../api/contructs";
import { createSyncedApiHook } from "../api/createSyncedApiHook";
import { createUseItemHook, createUseItemsHook } from "./createUseItemsHook";

const construct = constructs["filter-book"];

export const useFilterBook = createUseItemHook(construct);
export const useFilterBooks = createUseItemsHook(construct);
export const useFilterBooksApi = createSyncedApiHook(construct);
